import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../../app/store';

/**
 * Stores the app config
 */

interface AppConfigState {
  sidebarCollapsed: boolean;
  /**
   * Bumped whenever the cached profile is refreshed (e.g. after re-login via
   * the AuthModal) so components that read the profile from localStorage
   * non-reactively (like the Sidebar permissions) re-render with fresh data.
   */
  profileVersion: number;
}

const initialState: AppConfigState = {
  sidebarCollapsed: false,
  profileVersion: 0,
};

export const appConfigSlice = createSlice({
  name: 'appConfig',
  initialState,
  reducers: {
    /**
     * @param state  Current SelectedUser
     * @param action The new SelectedUser
     */
    setSidebarCollapsed: (state, action: PayloadAction<boolean>) => {
      state.sidebarCollapsed = action.payload;
    },
    /**
     * Force consumers of the cached profile to re-render.
     */
    bumpProfileVersion: (state) => {
      state.profileVersion += 1;
    },
  },
});

export const { setSidebarCollapsed, bumpProfileVersion } =
  appConfigSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const sidebarCollapsed = (state: RootState) =>
  state.appConfig.sidebarCollapsed;

export default appConfigSlice.reducer;
